import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Avatar,
  useTheme,
  Button,
  IconButton,
  Stack,
  Grow,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from "@mui/material";
import Chart from "react-apexcharts";
import WorkIcon from "@mui/icons-material/Work";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import LoopIcon from "@mui/icons-material/Loop";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { CalendarToday } from "@mui/icons-material";
import { Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import Datavisual1 from "./Calendar";
import { DashcalpostData } from "../../store/reducers/Formapireducer";
import { useDispatch, useSelector } from "react-redux";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import {
  dashBoardAtten,
  SprintBurnDown,
} from "../../store/reducers/LoginReducer";
import { useNavigate, useParams } from "react-router-dom";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import {
  dataGridHeaderFooterHeight,
  dataGridRowHeight,
} from "../../ui-components/global/utils";
import RecentActorsIcon from "@mui/icons-material/RecentActors";

import { tokens } from "../../Theme";
import { fetchListview } from "../../store/reducers/Listviewapireducer";
const ManagerDashbordSprint = () => {
  const dispatch = useDispatch();
  const empID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");

  const companyClassification = sessionStorage.getItem("Classification");
console.log(companyClassification, "-companyClassification");

  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const [isCalender, setIsCalender] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [weelyShow, setWeeklyShow] = useState("W");
  const [attendanceShow, setAttendanceShow] = useState("Y");
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [pageSize, setPageSize] = useState(31);
  const [rowCount, setRowCount] = useState(0);
  const [sprintStatusData, setSprintStatusData] = useState([]);
  const [sprintStatusTitle, setSprintStatusTitle] = useState("");
  const params = useParams();

  useEffect(() => {
    // dispatch(dashBoardTask({ data: { EmployeeID: empID } }));
    dispatch(
      dashBoardAtten({ data: { EmployeeID: empID, Type: params.Type } })
    );
  }, [params.Type]);
  const [isColor, setIsColor] = useState("C");

  // const summaryData = [
  //   {
  //     title: "Backlog Tasks - (18)",
  //     count: 18,
  //     gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
  //     icon: <HourglassTopIcon />,
  //     breakdown: ["Self (4)", "Manager (8)", "Sprint (6)"],
  //   },

  //   {
  //     title: "To do Tasks",
  //     count: 12,
  //     gradient: "linear-gradient(135deg, #17ead9, #6078ea)",
  //     icon: <LoopIcon />,
  //     breakdown: ["Self (4)", "Manager (6)", "Sprint (2)"],
  //   },

  //   {
  //     title: "Completed Tasks",
  //     count: 15,
  //     gradient: "linear-gradient(135deg, #42e695, #3bb2b8)",
  //     icon: <DoneAllIcon />,
  //     breakdown: ["Self (4)", "Manager (8)", "Sprint (3)"],
  //   },
  //   {
  //     title: "Total Tasks",
  //     count: 45,
  //     gradient: "linear-gradient(135deg, #ff6a00, #ee0979)",
  //     icon: <WorkIcon />,
  //     subtitle: "Approved Task: 55",
  //     breakdown: ["SPA (4)", "Approved (55)", "Blocked (3)"], // 👈 Add this line
  //   },
  // ];
  const summaryData = [
    {
      title: "Backlog Tasks",
      count: 18,
      gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
      icon: <HourglassTopIcon />,
      breakdown: ["Self (4)", "Manager (6)", "Sprint (2)"],
      breakdownFilters: {
        Self: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Self'`,
        Manager: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Manager'`,
        Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('AS','SH') AND TaskSource = 'Sprint'`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('SH','AS')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
    {
      title: "To do Tasks",
      count: 12,
      gradient: "linear-gradient(135deg, #17ead9, #6078ea)",
      icon: <LoopIcon />,
      breakdown: ["Self (4)", "Manager (6)", "Sprint (2)"],
      breakdownFilters: {
        Self: `EmployeesID='${empID}' AND FilterStatus IN ('I') AND TaskSource = 'Self'`,
        Manager: `EmployeesID='${empID}' AND FilterStatus IN ('I') AND TaskSource = 'Manager'`,
        Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('I') AND TaskSource = 'Sprint'`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('I')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
    {
      title: "Completed Tasks",
      count: 15,
      gradient: "linear-gradient(135deg, #42e695, #3bb2b8)",
      icon: <DoneAllIcon />,
      breakdown: ["Self (4)", "Manager (8)", "Sprint (3)"],
      breakdownFilters: {
        Self: `EmployeesID='${empID}' AND FilterStatus IN ('C') AND TaskSource = 'Self'`,
        Manager: `EmployeesID='${empID}' AND FilterStatus IN ('C') AND TaskSource = 'Manager'`,
        Sprint: `EmployeesID='${empID}' AND FilterStatus IN ('C') AND TaskSource = 'Sprint'`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('C')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
    {
      title: "Total Tasks",
      count: 45,
      gradient: "linear-gradient(135deg, #ff6a00, #ee0979)",
      icon: <WorkIcon />,
      subtitle: "Approved Task: 55",
      breakdown: ["SPA (4)", "Approved (55)", "Blocked (3)"],
      breakdownFilters: {
        SPA: `EmployeesID='${empID}' AND TaskSource = 'SpotActivity'`,
        Approved: `EmployeesID='${empID}' AND FilterStatus IN ('AP')`,
        Blocked: `EmployeesID='${empID}' AND FilterStatus IN ('B')`,
      },
      query: {
        AccessID: "TR277",
        ScreenName: "Scrum Task",
        Filter: `EmployeesID='${empID}' AND FilterStatus IN ('AP','B')`,
        Any: "",
        CompId: compID,
      },
      path: "/Apps/TR277/Scrum%20Task",
    },
  ];
  const handleCardClick = (item) => {
    // dispatch API call with that card's query
    dispatch(
      fetchListview(
        item.query.AccessID,
        item.query.ScreenName,
        item.query.Filter,
        item.query.Any,
        item.query.CompId
        // item.query.Type
      )
    );
    // navigate to the route
    navigate(item.path);
  };
  const handleBreakdownClick = (filter) => {
    const AccessID = "TR277";
    const ScreenName = "Scrum Task";
    const Any = "";
    const CompId = compID;

    dispatch(fetchListview(AccessID, ScreenName, filter, Any, CompId));

    navigate("/Apps/TR277/Scrum%20Task");
  };
  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Sprint</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const projectRows = [
    {
      SLNO: 1,
      prjctname: "Sprint 1 -ESS(08-05-2026 to 06-07-2026)",
      Backlog: 50,
      Todo: 20,
      Completed: 30,
      Approved: 25,
      Total: 80,
    },
    {
      SLNO: 2,
      prjctname: "Sprint 2 -LGEMS(08-05-2026 to 06-07-2026)",
      Backlog: 56,
      Todo: 47,
      Completed: 26,
      Approved: 28,
      Total: 60,
    },
    {
      SLNO: 3,
      prjctname: "Sprint 3 -HR(08-05-2026 to 06-07-2026)",
      Backlog: 48,
      Todo: 36,
      Completed: 48,
      Approved: 78,
      Total: 50,
    },
  ];

  const ProjectColumn = [
    // {
    //   field: "SLNO",
    //   headerName: "SL#",
    //   width: 50,
    //   headerAlign: "center",
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 50,
      sortable: false,
      filterable: false,
      valueGetter: (params) =>
        `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    },

    {
      field: "SprintDetails",
      headerName: "Sprint Name",
      width: 200,
      headerAlign: "center",
    },

    {
      field: "BacklogSprint",
      headerName: "Backlog",
      flex: 1,
      headerAlign: "center",
      align: "right",
    },

    {
      field: "Todo",
      headerName: "Todo",
      flex: 1,
      headerAlign: "center",
      align: "right",
    },

    {
      field: "Completed",
      headerName: "Completed",
      flex: 1,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "Approved",
      headerName: "Approved",
      flex: 1,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "Total",
      headerName: "Total",
      flex: 1,
      headerAlign: "center",
      align: "right",
    },
  ];

  const dashBoardAttenGetData = useSelector(
    (state) => state.loginApi.dashBoardAttenGetData
  );
  console.log("🚀 ~ Dash ~ dashBoardAttenGetData:", dashBoardAttenGetData);
  const dashBoardAttenGetStaus = useSelector(
    (state) => state.loginApi.dashBoardAttenGetStaus
  );
  console.log("🚀 ~ dashBoardAttenGetStaus:", dashBoardAttenGetStaus);
  const dashBoardAttenGetLoading = useSelector(
    (state) => state.loginApi.dashBoardAttenGetLoading
  );
  const dashBoardAttenGetError = useSelector(
    (state) => state.loginApi.dashBoardAttenGetError
  );

  const sprintBurndownGetData = useSelector(
    (state) => state.loginApi.sprintBurndownGetData
  );
  const sprintBurndownGetStatus = useSelector(
    (state) => state.loginApi.sprintBurndownGetStatus
  );
  const sprintBurndownGetLoading = useSelector(
    (state) => state.loginApi.sprintBurndownGetLoading
  );

  const pieData = {
    series:
      isColor == "C"
        ? dashBoardAttenGetData?.agingData?.completedData
        : isColor == "B"
          ? dashBoardAttenGetData?.agingData?.backlogData
          : dashBoardAttenGetData?.agingData?.todoData,
    options: {
      labels: ["Today", "This Week", ">1 Week"],
      chart: { type: "donut" },
      legend: { position: "bottom" },
      colors:
        isColor == "C"
          ? ["#00695f", "#009688", "#33ab9f"]
          : isColor == "B"
            ? ["#aa2e25", "#f44336", "#f6685e"]
            : ["#2c387e", "#3f51b5", "#6573c3"],
    },
  };

  const projectTaskData = {
    xaxis: ["Sprint 1 - ESS", "Sprint 2 - LGEMS", "Sprint 3 - UAAM "],
    yaxis: [
      {
        name: "Backlog",
        data: [458, 551, 70],
      },
      {
        name: "Todo",
        data: [449, 285, 51],
      },
      {
        name: "Completed",
        data: [185, 123, 89],
      },

      {
        name: "Approved",
        data: [400, 134, 35],
      },
    ],
  };

  const chartOptions = {
    chart: { type: "bar", stacked: false, toolbar: { show: false } },
    colors: ["#e91e63", "#ff9800", "#4caf50", "#00695F", "#1976d2"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 4,
        distributed: true,
      },
    },

    xaxis: {
      // categories: ["Total", "To do", "Backlog", "Completed"],
      categories: ["Backlog", "To do", "Completed", "Approved", "Total"],
    },
    dataLabels: { enabled: false },
    legend: { position: "bottom" },
  };

  const chartOptionsLine = {
    chart: {
      id: "task-status-tracker",
      type: "line",
      toolbar: { show: false },
    },
    xaxis: {
      categories: sprintBurndownGetData.xaxis,
      type: "date",
      title: { text: "Sprint Days" },
    },
    yaxis: {
      tickAmount: 9,
      title: { text: "Hours" },
    },
    markers: {
      size: 4,
    },
    stroke: {
      curve: "straight",
    },
    tooltip: {
      x: { format: "dd MM yyyy" },
      y: {
        // formatter: (val) => val || "",
        formatter: (val) => (val ?? 0) + " hrs"
      },
    },
    legend: {
      show: false, // 🔒 Hide the legend
    },
  };
  return (
    <Box p={3} sx={{ background: "#FFFFFF" }}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {companyClassification === "Board Of Directors" ? "PRINCIPAL DASHBOARD"
         : companyClassification === "Staff" ? "STAFF DASHBOARD" : 
         companyClassification === "Intern" ? "STUDENT DASHBOARD" : "SCRUM MASTER DASHBOARD"}
        </Typography>
        <Stack direction={"row"} gap={2}>
          <Tooltip title="Employee Dashboard">
            <IconButton
              onClick={() => {
                navigate("/Apps/dashbord/E");
                dispatch(
                  dashBoardAtten({ data: { EmployeeID: empID, Type: "E" } })
                );
              }}
              color="primary"
              aria-label="add an alarm"
            >
              <RecentActorsIcon />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={isCalender ? "Scrum Master Dashboard" : "Task Calendar"}
          >
            <IconButton
              onClick={() => setIsCalender(!isCalender)}
              color="primary"
            // title="D"
            >
              {isCalender ? <DashboardIcon /> : <CalendarToday />}
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      {!isCalender ? (
        <React.Fragment>
          <Grid container spacing={3}>
            {/* {dashBoardAttenGetData.taskSummaryCardData.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    background: item.gradient,
                    color: "#fff",
                    height: 150,
                    borderRadius: 3,
                    boxShadow: 4,
                  }}
                >
                  <CardContent
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {item.title}
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                          {item.count}
                        </Typography>
                      </Box>
                      <Avatar sx={{ bgcolor: "white", color: "#000" }}>
                        {summaryData[index]["icon"]}
                      </Avatar>
                    </Box>

                    {item.breakdown && (
                      <Box mt={1}>
                        {item.breakdown.map((b, i) => (
                          <Typography
                            key={i}
                            ml={0.5}
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              mt: 0.5,
                              px: 1,
                              py: 0.3,
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                              borderRadius: 1,
                              display: "inline-block",
                            }}
                          >
                            • {b}
                          </Typography>
                        ))}
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))} */}
            {dashBoardAttenGetData.taskSummaryCardData.map((item, index) => {
              // merge API item + static summaryData
              const mergedItem = { ...summaryData[index], ...item };

              return (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    sx={{
                      background: mergedItem.gradient,
                      color: "#fff",
                      height: 150,
                      borderRadius: 3,
                      boxShadow: 4,
                      cursor: "pointer",
                      // marginTop: "20px",
                      // marginLeft: "15px",
                      transition: "transform 0.2s",
                      "&:hover": { transform: "scale(1.05)" },
                    }}
                  // ✅ mergedItem has query + count
                  >
                    <CardContent
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box onClick={() => handleCardClick(mergedItem)}>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {mergedItem.title}
                          </Typography>
                          <Typography variant="h4" fontWeight="bold">
                            {mergedItem.count}
                          </Typography>
                        </Box>
                        <Avatar
                          sx={{ bgcolor: "white", color: "#000" }}
                        // onClick={() => handleCardClick(mergedItem)}
                        >
                          {mergedItem.icon}
                        </Avatar>
                      </Box>

                      {mergedItem.breakdown && (
                        <Box mt={1}>
                          {/* {mergedItem.breakdown.map((b, i) => (
                                        <Typography
                                          key={i}
                                          ml={0.5}
                                          variant="body2"
                                          sx={{
                                            fontWeight: "bold",
                                            mt: 0.5,
                                            px: 1,
                                            py: 0.3,
                                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                                            borderRadius: 1,
                                            display: "inline-block",
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
            
                                            // get only the word before space or "("
                                            const prefix = b.split(" ")[0]; // "Self (4)" -> "Self"
            
                                            const filter = breakdownFilters[prefix];
            
                                            console.log("Breakdown filter:", filter);
                                            handleBreakdownClick(filter);
                                          }}
                                        >
                                          • {b}
                                        </Typography>
                                      ))} */}
                          {mergedItem.breakdown && (
                            <Box mt={1}>
                              {mergedItem.breakdown.map((b, i) => (
                                <Typography
                                  key={i}
                                  ml={0.5}
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    mt: 0.5,
                                    px: 1,
                                    py: 0.3,
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.15)",
                                    borderRadius: 1,
                                    display: "inline-block",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    const prefix = b.split(" ")[0]; // "Self (4)" -> "Self"
                                    const filter =
                                      mergedItem.breakdownFilters[prefix]; // ✅ per-card filter

                                    console.log("Breakdown filter:", filter);
                                    handleBreakdownClick(filter);
                                  }}
                                >
                                  • {b}
                                </Typography>
                              ))}
                            </Box>
                          )}
                        </Box>
                      )}
                      {/* {mergedItem.breakdown && (
                                      <Box mt={1}>
                                        {mergedItem.breakdown.map((b, i) => (
                                          <Typography
                                            key={i}
                                            ml={0.5}
                                            variant="body2"
                                            sx={{
                                              fontWeight: "bold",
                                              mt: 0.5,
                                              px: 1,
                                              py: 0.3,
                                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                                              borderRadius: 1,
                                              display: "inline-block",
                                              cursor: "pointer", // indicate clickable
                                            }}
                                            onClick={() => handleBreakdownClick(b.filter)}
                                          >
                                            • {b.label}
                                          </Typography>
                                        ))}
                                      </Box>
                                    )} */}
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          <Grid container spacing={1} mt={2}>
            {/* Task Distribution */}
            <Grid item xs={12} md={6}>
              <Card sx={{ borderRadius: 2, boxShadow: 2, height: "100%" }}>
                <Box
                  height="300px"
                  // height={dataGridHeight}
                  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },

                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                    "& .weekoff-row": {
                      backgroundColor: "#f2acb7", // light red
                      color: "#b71c1c", // dark red text
                    },
                    "& .holiday-row": {
                      backgroundColor: "#c9f5cc", // light green
                      color: "#1b5e20", // dark green text
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={
                      dashBoardAttenGetData.projectTaskData.leaveDetailsData
                        .tableData
                    }
                    columns={ProjectColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onCellClick={(params) => {
                      console.log(
                        "🚀 ~ ManagerDashbordSprint ~ params:",
                        params
                      );
                      dispatch(
                        SprintBurnDown({
                          data: { sprintId: params.row.SH_RECID },
                        })
                      );
                      setSprintStatusTitle(params.row.SprintDetails);
                      // setSprintStatusData([{data:[params.row.BacklogSprint,params.row.Todo,params.row.Completed,params.row.Approved,params.row.Total]}])
                    }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card sx={{ borderRadius: 2, boxShadow: 2, height: "100%" }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                // mb={1}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    Sprint Burndown {sprintStatusTitle}
                  </Typography>
                </Box>

                <Chart
                  height={300}
                  width={"100%"}
                  options={chartOptionsLine}
                  series={sprintBurndownGetData.yaxis}
                  type="line"
                // height={220}
                />
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={1} mt={2}>
            <Grid item xs={12}>
              <Card
                sx={{ p: 2, borderRadius: 2, boxShadow: 2, height: "100%" }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    Sprint Task Summary
                  </Typography>
                </Box>
                <Chart
                  type="bar"
                  height={220}
                  options={{
                    chart: {
                      toolbar: { show: false },
                    },
                    xaxis: {
                      categories: dashBoardAttenGetData.projectTaskData.xaxis,
                    },
                    colors: [
                      "#42a5f5",
                      "#40DB9C",
                      "#FECA04",
                      "#FF9800",
                      "#00695F",
                    ],
                    plotOptions: {
                      bar: {
                        borderRadius: 6,
                        columnWidth: "10%",
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },
                  }}
                  series={dashBoardAttenGetData.projectTaskData.yaxis}
                />
              </Card>
            </Grid>
          </Grid>
        </React.Fragment>
      ) : (
        false
      )}

      {isCalender ? (
        <Paper
          elevation={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            mt: 2,
            p: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            px={2}
            mb={1}
          >
            {/* 🔹 Legends */}
            <Box display="flex" alignItems="center" gap={2}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    // backgroundColor: "#a7f0f3",
                    backgroundColor: "#b9ecee",
                    borderRadius: "3px",
                  }}
                />
                <span style={{ fontSize: "13px" }}>Holiday</span>
              </Box>

              <Box display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    // backgroundColor: "#ee7b8c96",
                    backgroundColor: "#f3bac296",
                    borderRadius: "3px",
                  }}
                />
                <span style={{ fontSize: "13px" }}>Week Off</span>
              </Box>

              <Box display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    // backgroundColor: "#f3cd9b",
                    backgroundColor: "#ddcab1",
                    borderRadius: "3px",
                  }}
                />
                <span style={{ fontSize: "13px" }}>Leave</span>
              </Box>
            </Box>
            {isManager === "1" && (
              <Employeeautocomplete
                sx={{ width: 250 }}
                name="empName"
                label="Employee"
                id="empName"
                value={selectedEmp}
                onChange={(newValue) => {
                  console.log(newValue, "--find newValue");

                  if (newValue) {
                    setSelectedEmp(newValue);
                    const selectedEmpID = newValue.RecordID;

                    dispatch(
                      DashcalpostData({
                        Year: "2026",
                        Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                        EmployeeID: selectedEmpID,
                      })
                    );
                  } else {
                    dispatch(
                      DashcalpostData({
                        Year: "2026",
                        Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                        EmployeeID: empID,
                        // EmployeeID: selectedEmpID,
                      })
                    );
                  }
                }}
                url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${empID}","Any":"","CompId":${compID}}}`}
              />
            )}
          </Box>
          <Datavisual1 />
        </Paper>
      ) : (
        false
      )}
    </Box>
  );
};

export default ManagerDashbordSprint;
